import { render, staticRenderFns } from "./CarouselGallery.vue?vue&type=template&id=2b330586&"
import script from "./CarouselGallery.vue?vue&type=script&lang=js&"
export * from "./CarouselGallery.vue?vue&type=script&lang=js&"
import style0 from "./CarouselGallery.vue?vue&type=style&index=0&id=2b330586&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports